<template>
	<div>
		<template v-if="device!='pc'">
			<template v-for="(item , index) in template">
				<div :key="index">
					<van-divider>{{getgroupname(index)}}</van-divider>
					<van-grid :square="true">
						<template v-for="(_item,_index) in item">
							<van-grid-item @click="open(_item)" :key="_index" :text="_item.name">
								<template #icon>
									<van-icon color="#F56C6C" size="20" name="orders-o" />
								</template>
							</van-grid-item>
						</template>
					</van-grid>
				</div>
			</template>
		</template>
		<template v-else>
			<div class="full box">
				<el-collapse v-model="activeNames" @change="handleChange">
					<el-collapse-item :name="index" v-for="(item,index) in template" :key="index">
						<template slot="title">
							<div style="font-size: 14px;font-weight: bold;">{{getgroupname(index)}}</div>
						</template>
						<el-row>
							<el-col style="margin-bottom: 0px;" :span="4" v-for="(_item,_index) in item" :key="_index">
								<el-link :underline="true" @click="open(_item)"><i style="color: #F56C6C;"
										class="el-icon-tickets el-icon--left"></i>{{_item.name}}
								</el-link>
							</el-col>
						</el-row>
					</el-collapse-item>
				</el-collapse>
			</div>
			<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />
		</template>
	</div>

</template>
<style scoped>
	.box {
		box-sizing: border-box;
		padding: 4px 20px;
		overflow: auto;
	}

	.item {
		flex-direction: row;
		align-items: center;
	}
</style>
<script>
	export default {
		name: 'flowtemplateIndex',
		props: {

		},
		data() {
			return {
				activeNames: [],
				template: [],
				formwindowShow: false,
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					foreingKey: {},
					extra: {},
				},
				device: window.systemMethods.device(),
			}
		},
		watch: {

		},
		created() {
			this.list()
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			formBack(e) {
				this.formwindowShow = false
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
				if (e.type != 'cancle') {
					this.customreload()
				}
			},
			list() {
				return new Promise((reslove) => {
					let obj = {}
					this.$api.flow.getTotalFlowTemplate().then((res) => {
						res.forEach((item) => {
							if (!obj[item.groupid]) {
								this.activeNames.push(String(item.groupid))
								obj[item.groupid] = []
							}
							obj[item.groupid].push(item)
						})

						this.template = obj
						reslove()
					})
				})
			},
			open(item) {
				console.log(item)
				this.$api.flow.getSingleFlowTemplate(item.id).then((e) => {
					if (e) {
						let res = this.$router.resolve({
							name: 'add',
							query: {
								name: item.formname,
								id: 0,
								controlltype: 1,
								windowName: item.name,
								extra: JSON.stringify({
									componentname: item.componentname
								}),
								isflow: 1,
								flowid: item.id
							}
						})
						if (this.device != 'pc') {
							this.$router.push(res.href.replace(/#/g, ''))
						} else {
							let win = window.open(res.href, item.formname + "add",
								this.$store.state.system.windowConfig)
							win.onload = () => {
								console.log(item.formname + 'form open')
							}
						}

					}
				})
			},
			getgroupname(value) {
				return window.systemMethods.getEmunValue('flowgroup', value)
			},
			handleChange() {

			}
		},
		components: {

		}
	}
</script>
